module.exports = __webpack_public_path__ + "assets/img/4_140.ff041767.jpg";